// Lightweight, signature-less inspection of a JWT access token.
//
// Used to refresh the access token *proactively* (before sending a request)
// when it is about to expire. This avoids the "send body -> 401 -> retry the
// whole body" pattern, which on large file uploads caused the upstream to
// reset the connection (502 via the reverse proxy).

// Decode the payload segment of a JWT without verifying its signature.
function decodeJwtPayload(token) {
    try {
        const part = String(token).split('.')[1];
        if (!part) return null;
        const b64 = part.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(b64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(json);
    } catch (e) {
        return null;
    }
}

// True if the token is missing, unparseable, has no expiry, or expires within
// `bufferSeconds`. When true, the caller should refresh before using it.
function isTokenExpiredOrExpiring(token, nowMs, bufferSeconds = 30) {
    if (!token) return true;
    const payload = decodeJwtPayload(token);
    if (!payload || typeof payload.exp !== 'number') return true;
    return payload.exp * 1000 <= nowMs + bufferSeconds * 1000;
}

module.exports = { isTokenExpiredOrExpiring, decodeJwtPayload };
